// extracted by mini-css-extract-plugin
export var actionButton = "_ry-0";
export var actionMenuContainer = "_ry-i";
export var bubble = "_ry-2";
export var bubbleActionMenu = "_ry-j";
export var bubbleContext = "_ry-6";
export var bubbleItems = "_ry-7";
export var customer = "_ry-3";
export var divider = "_ry-8";
export var fileList = "_ry-9";
export var hiddenComment = "_ry-o";
export var infoAbove = "_ry-a";
export var internal = "_ry-4";
export var lightActionButton = "_ry-1";
export var link = "_ry-b";
export var merchant = "_ry-5";
export var message = "_ry-c";
export var profilePicture = "_ry-e";
export var quillToolbarContainer = "_ry-f";
export var senderDate = "_ry-g";
export var senderDateCustomer = "_ry-h";
export var senderName = "_ry-d";
export var time = "_ry-k";
export var uploadedImage = "_ry-l";
export var username = "_ry-m";
export var xsmall = "_ry-n";